import { render, staticRenderFns } from "./EditNote.vue?vue&type=template&id=6224bf59&"
import script from "./EditNote.vue?vue&type=script&lang=js&"
export * from "./EditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports